<template>
    <div class="container"> 
        <div class="row justify-content-center mb-5">
            <img :src="getEnvAsset(`/images/logo${variant !== undefined ? `-${variant}` : ''}.svg`)" alt="App logo" class="h-70 my-3">
        </div>
    </div>
</template>
<script>
import getEnvAsset from '@/utils/methods/env_assets';

export default {
    name: "AppLogo",
    props: {
        variant: {
            type: String,
            required: false,
        }
    },
    methods: {
        getEnvAsset: getEnvAsset
    }
};
</script>